import React from 'react';
import { Logo } from '@repo/common';
import { IS_LEGACY_DOMAIN } from '../../utils/brand.js';

const LogoOnlyGNB = ({ className = '', type = 'gray' }) => {
  // 'plain': 흰 배경 + 하단 테두리 없음 (흰 페이지에 이어지는 GNB)
  const bgClass =
    type === 'white'
      ? 'bg-grayscale-gray00 border-b border-grayscale-gray02'
      : type === 'plain'
        ? 'bg-grayscale-gray00'
        : 'bg-grayscale-gray01';

  return (
    <>
      <div className='h-[44px] tabletH:h-[74px]' />

      <div
        className={`fixed top-0 left-0 w-full z-[10] tabletH:h-[74px] h-[44px] flex flex-row items-center tabletH:px-[80px] px-[20px] py-3 ${bgClass} ${className}`}
      >
        <Logo brand={IS_LEGACY_DOMAIN ? 'oing' : 'koready'} />
      </div>
    </>
  );
};

export default LogoOnlyGNB;
